export interface AddressPoint {
    address?: string | null
    cityId?: number | null
    cityName?: string | null
    streetHouse?: string | null
    countryName?: string | null
}

export function formatAddress(
    p: AddressPoint,
    selected?: { cityId?: number | null; countryName?: string | null } | null
): string {
    const street = p.streetHouse ?? p.address ?? ''
    const sameCity = !!p.cityId && p.cityId === selected?.cityId
    let out = street
    if (!sameCity && p.cityName) out = `${p.cityName}, ${street}`
    if (
        p.countryName &&
        selected?.countryName &&
        p.countryName !== selected.countryName
    ) {
        out = `${p.countryName}, ${out}`
    }
    return out
}
